import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import fundReducer from './slices/fundSlice';
import themeReducer from './slices/themeSlice';
import websocketReducer from './slices/websocketSlice';
import { websocketMiddleware } from './middleware/websocketMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    fund: fundReducer,
    theme: themeReducer,
    websocket: websocketReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setUser', 'websocket/connect', 'websocket/subscribe'],
        ignoredPaths: ['auth.user', 'websocket.latestTrade', 'websocket.latestPosition'],
      },
    }).concat(websocketMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
